// Example Extend!!!
// Please follow this, don`t change theme.js

import {FreeShippingBar} from "theme";


class CustomFreeShippingBar extends FreeShippingBar {
   constructor() {
       super();
   }

   connectedCallback() {
       super.connectedCallback();
       document.addEventListener("cart:change", this.updateColors.bind(this));
       // Initial color update
       this.updateColors();
   }

   attributeChangedCallback() {
       super.attributeChangedCallback();
       // Update colors when attributes change (totalPrice or threshold)
       this.updateColors();
   }

   updateColors() {
       const threshold = parseFloat(this.getAttribute("threshold"));
       const totalPrice = parseFloat(this.getAttribute("total-price"));

       // Check if goal is reached
       const isReached = totalPrice >= threshold;

       if (isReached) {
           // Goal reached
           this.classList.remove('in-progress');
       } else {
           // Goal not reached
           this.classList.add('in-progress');
       }
   }

   setProgressBar() {
       // Legacy method, kept for compatibility
       this.updateColors();
   }
}


window.customElements.define('custom-free-shipping-bar', CustomFreeShippingBar);


// Patch DialogElement so that clicks inside the Size Guide popup (or any other
// active custom overlay that is NOT a DialogElement) do not trigger hide() on
// underlying dialogs (quick-buy-modal, cart-drawer, etc.).
customElements.whenDefined('dialog-element').then(() => {
  const DialogElementClass = customElements.get('dialog-element');
  if (!DialogElementClass) return;

  const original = DialogElementClass.prototype.hideForOutsideClickTarget;
  DialogElementClass.prototype.hideForOutsideClickTarget = function(target) {
    // Don't close if the click landed inside the Size Guide modal or its overlay
    const sizeGuide = document.getElementById('sizeGuideModal');
    if (sizeGuide && sizeGuide.classList.contains('active') && sizeGuide.contains(target)) {
      return false;
    }

    const sizeGuideOverlay = document.getElementById('sizeGuideOverlay');
    if (sizeGuideOverlay && sizeGuideOverlay.contains(target)) {
      return false;
    }

    return original.call(this, target);
  };
});

(() => {
  const BANNER_ID = 'pandectes-banner';
  const STORAGE_KEY = 'pandectesBannerHidden';
  const DELAY_MS = 3000;
  const TIMEOUT_GIVE_UP_MS = 10000;


  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    const style = document.createElement('style');
    style.innerHTML = `#${BANNER_ID} { display: none !important; }`;
    document.head.appendChild(style);
    return;
  }

  const hideBanner = (element) => {
    setTimeout(() => {
      element.style.setProperty('display', 'none', 'important');
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }, DELAY_MS);
  };


  const existingBanner = document.getElementById(BANNER_ID);
  if (existingBanner) {
    hideBanner(existingBanner);
    return;
  }


  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.id === BANNER_ID) {
            hideBanner(node);
            obs.disconnect();
            return;
          }

          const childBanner = node.querySelector(`#${BANNER_ID}`);
          if (childBanner) {
            hideBanner(childBanner);
            obs.disconnect();
            return;
          }
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  setTimeout(() => {
    observer.disconnect();
  }, TIMEOUT_GIVE_UP_MS);
})();

// Auto-open sidebar menu after successful newsletter signup
(() => {
  const setupNewsletterForms = () => {
    const forms = document.querySelectorAll('.header-sidebar__vip-form');
    
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput && emailInput.value.trim()) {
          const isSubmenu = form.id.includes('submenu');
          if (isSubmenu) {
            const panelMatch = form.id.match(/header-panel-(\d+)/);
            if (panelMatch) {
              sessionStorage.setItem('header-sidebar-newsletter-pending', `submenu-${panelMatch[1]}`);
            } else {
              sessionStorage.setItem('header-sidebar-newsletter-pending', 'main');
            }
          } else {
            sessionStorage.setItem('header-sidebar-newsletter-pending', 'main');
          }
        }
      });
    });
  };

  const checkAndOpenSidebar = () => {
    const successFlag = sessionStorage.getItem('header-sidebar-newsletter-success');
    const pendingFlag = sessionStorage.getItem('header-sidebar-newsletter-pending');
    
    if (!successFlag && !pendingFlag) return;

    const sidebarMenu = document.getElementById('sidebar-menu');
    if (!sidebarMenu) {
      setTimeout(checkAndOpenSidebar, 100);
      return;
    }

    if (successFlag || pendingFlag) {
      if (!sidebarMenu.hasAttribute('open')) {
        sidebarMenu.setAttribute('open', '');
        
        const flagToUse = successFlag || pendingFlag;
        if (flagToUse.startsWith('submenu-')) {
          const panelIndex = flagToUse.replace('submenu-', '');
          const collapsiblePanel = sidebarMenu.querySelector('header-sidebar-collapsible-panel');
          if (collapsiblePanel) {
            const subPanel = sidebarMenu.querySelector(`#header-panel-${panelIndex}`);
            if (subPanel) {
              setTimeout(() => {
                collapsiblePanel.setAttribute('aria-activedescendant', `header-panel-${panelIndex}`);
              }, 300);
            }
          }
        }

        if (successFlag) {
          sessionStorage.removeItem('header-sidebar-newsletter-success');
        }
        if (pendingFlag) {
          sessionStorage.removeItem('header-sidebar-newsletter-pending');
          sessionStorage.setItem('header-sidebar-newsletter-success', flagToUse);
        }
      }
    }
  };

  const init = () => {
    setupNewsletterForms();
    // checkAndOpenSidebar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  const observer = new MutationObserver(() => {
    setupNewsletterForms();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// Close sidebar when clicking cart links
(() => {
  const setupCartLinkHandlers = () => {
    const cartLinks = document.querySelectorAll('a[data-close-sidebar]');
    const sidebarMenu = document.getElementById('sidebar-menu');

    cartLinks.forEach(link => {
      if (link.hasAttribute('data-close-sidebar-handler')) return;

      link.setAttribute('data-close-sidebar-handler', 'true');
      link.addEventListener('click', (e) => {
        if (sidebarMenu && sidebarMenu.hasAttribute('open')) {
          sidebarMenu.removeAttribute('open');

          // Also close any open sub-panels
          const collapsiblePanel = sidebarMenu.querySelector('header-sidebar-collapsible-panel');
          if (collapsiblePanel && collapsiblePanel.hasAttribute('aria-activedescendant')) {
            collapsiblePanel.removeAttribute('aria-activedescendant');
          }
        }
      });
    });
  };

  const init = () => {
    setupCartLinkHandlers();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  // Watch for dynamically added cart links
  const observer = new MutationObserver(() => {
    setupCartLinkHandlers();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// =============================================================================
// HEADER: Cart Count Visibility
// Moved from inline <script> in sections/header.liquid
// =============================================================================
(() => {
  const cartCountElements = document.querySelectorAll('.shopify-section--header cart-count');
  cartCountElements.forEach((element) => {
    const updateVisibility = () => {
      const count = parseInt(element.innerText) || 0;
      element.classList.toggle('is-hidden', count === 0);
    };

    updateVisibility();

    document.addEventListener('cart:change', (event) => {
      const count = event.detail?.cart?.item_count || 0;
      element.classList.toggle('is-hidden', count === 0);
    });

    document.addEventListener('cart:refresh', updateVisibility);

    window.addEventListener('pageshow', async (event) => {
      if (!event.persisted) return;
      const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
      element.classList.toggle('is-hidden', cart.item_count === 0);
    });
  });
})();

// =============================================================================
// HEADER: Sync Mega Menu Heights on Desktop
// Moved from inline <script> in sections/header.liquid
// =============================================================================
(function () {
  let megaMenuHeightTimeout;

  function syncMegaMenuHeights() {
    const headerSection = document.querySelector('.shopify-section--header');
    if (!headerSection) return;

    if (window.innerWidth < 1000) {
      const megaMenus = Array.from(headerSection.querySelectorAll('details.header__menu-disclosure .mega-menu'));
      megaMenus.forEach(menu => (menu.style.minHeight = ''));
      return;
    }

    const megaMenus = Array.from(headerSection.querySelectorAll('details.header__menu-disclosure .mega-menu'));
    if (megaMenus.length < 2) return;

    megaMenus.forEach(menu => (menu.style.minHeight = ''));

    let maxHeight = 0;

    megaMenus.forEach(menu => {
      const details = menu.closest('details');
      if (!details) return;

      const originalOpen = details.hasAttribute('open');
      const originalVisibility = menu.style.visibility;
      const originalTransition = menu.style.transition;
      const originalOpacity = menu.style.opacity;

      if (!originalOpen) details.setAttribute('open', '');

      menu.style.visibility = 'hidden';
      menu.style.transition = 'none';
      menu.style.opacity = '0';

      const height = menu.offsetHeight;
      if (height > maxHeight) maxHeight = height;

      if (!originalOpen) details.removeAttribute('open');

      menu.style.visibility = originalVisibility;
      menu.style.transition = originalTransition;
      menu.style.opacity = originalOpacity;
    });

    if (maxHeight > 0) {
      megaMenus.forEach(menu => (menu.style.minHeight = maxHeight + 'px'));
    }
  }

  document.addEventListener('DOMContentLoaded', syncMegaMenuHeights);
  window.addEventListener('load', syncMegaMenuHeights);
  window.addEventListener('resize', () => {
    clearTimeout(megaMenuHeightTimeout);
    megaMenuHeightTimeout = setTimeout(syncMegaMenuHeights, 150);
  });
})();

// =============================================================================
// HEADER SIDEBAR: Sub-panel Navigation (Back button + Title)
// Moved from inline <script> in snippets/header-sidebar.liquid
// =============================================================================
(function () {
  customElements.whenDefined('header-sidebar').then(function () {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || !sidebar.shadowRoot) return;

    const shadowRoot = sidebar.shadowRoot;
    const menuLabel = shadowRoot.querySelector('.header-sidebar__menu-label');
    const backButton = shadowRoot.querySelector('.header-sidebar__back-button');
    const titleEl = shadowRoot.querySelector('.header-sidebar__panel-title');
    const collapsiblePanel = sidebar.querySelector('header-sidebar-collapsible-panel');

    function getButtonTitle(btn) {
      const withSub = btn.querySelector('.header-sidebar__link-with-subtitle span:first-child');
      if (withSub) return withSub.textContent.trim();
      let title = '';
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const t = node.textContent.trim();
          if (t) title += t;
        }
      });
      return title.trim();
    }

    function showSubPanel(title) {
      if (menuLabel) menuLabel.hidden = true;
      if (backButton) backButton.hidden = false;
      if (titleEl) titleEl.textContent = title;
    }

    function resetHeader() {
      if (menuLabel) menuLabel.hidden = false;
      if (backButton) backButton.hidden = true;
      if (titleEl) titleEl.textContent = '';
    }

    const mainPanel = sidebar.querySelector('.header-sidebar__main-panel');
    if (mainPanel) {
      mainPanel.addEventListener('click', function (e) {
        const btn = e.target.closest('[aria-controls]');
        if (btn) showSubPanel(getButtonTitle(btn));
      });
    }

    if (backButton && collapsiblePanel) {
      backButton.addEventListener('click', function () {
        collapsiblePanel.removeAttribute('aria-activedescendant');
        if (typeof sidebar.revealItems === 'function') sidebar.revealItems(true);
        resetHeader();
      });
    }

    sidebar.addEventListener('dialog:after-hide', resetHeader);

    if (collapsiblePanel) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (
            m.attributeName === 'aria-activedescendant' &&
            !collapsiblePanel.hasAttribute('aria-activedescendant')
          ) {
            resetHeader();
          }
        });
      }).observe(collapsiblePanel, { attributes: true });
    }
  });
})();

// =============================================================================
// MEGA MENU: Hover Intent + Smart Switching + Re-entry Gate
//
// Three behaviours implemented here (base theme has none of these):
//
// 1. HOVER INTENT (500ms, Baymard Institute)
//    First hover on a nav item requires 500ms of intent before opening.
//    Prevents accidental opens during passing/diagonal mouse movement.
//
// 2. INSTANT SWITCH between menus
//    Once any mega menu is open (session active), moving to another nav item
//    opens it immediately. Session ends 600ms after all menus have closed.
//
// 3. RE-ENTRY GATE — nav item only
//    After the cursor leaves the mega menu area and returns directly to the
//    dropdown content (not the nav item / summary), the menu stays closed.
//    Fixes "ghost re-open" during close animation and accidental reopens
//    when cursor returns from below the header.
//
// Implementation note on the gate:
//    mouseover fires BEFORE mouseenter (spec order), so a mouseenter-based
//    flag would not be set yet when open() is called. Instead we check the
//    live CSS :hover state on summary — the browser updates :hover before
//    dispatching mouseover, so summary.matches(':hover') is always accurate.
// =============================================================================
(function () {
  const HOVER_INTENT_DELAY = 500;
  const SESSION_TIMEOUT = 600;

  let megaMenuSession = false;
  let sessionResetTimer = null;
  let switchingMenus = false; // skips close animation during instant switch

  function startSession() {
    megaMenuSession = true;
    clearTimeout(sessionResetTimer);
    sessionResetTimer = null;
  }

  function scheduleSessionEnd() {
    clearTimeout(sessionResetTimer);
    sessionResetTimer = setTimeout(() => {
      megaMenuSession = false;
      sessionResetTimer = null;
    }, SESSION_TIMEOUT);
  }

  customElements.whenDefined('mega-menu-disclosure').then(function () {
    const MegaMenuDisclosure = customElements.get('mega-menu-disclosure');
    if (!MegaMenuDisclosure) return;

    const originalOpen = MegaMenuDisclosure.prototype.open;
    const originalClose = MegaMenuDisclosure.prototype.close;
    const originalCreateHideAnim = MegaMenuDisclosure.prototype.createHideAnimationControls;

    // When switching menus, finish the close animation immediately (no fade-out)
    MegaMenuDisclosure.prototype.createHideAnimationControls = function () {
      const controls = originalCreateHideAnim.call(this);
      if (switchingMenus && controls) {
        controls.finish();
      }
      return controls;
    };

    MegaMenuDisclosure.prototype.open = function (options) {
      // Already open: cursor moving within the open dropdown — pass through.
      if (this.disclosureElement.getAttribute('aria-expanded') === 'true') {
        return originalOpen.call(this, options);
      }

      // Touch / click mode: open instantly, no hover logic.
      if (this.trigger !== 'hover') {
        return originalOpen.call(this, options);
      }

      // RE-ENTRY GATE
      // Block open if cursor entered via dropdown content (not via summary).
      const summary = this.disclosureElement.querySelector('summary');
      if (summary && !summary.matches(':hover')) {
        clearTimeout(this._hoverIntentTimer);
        this._hoverIntentTimer = null;
        return;
      }

      // INSTANT SWITCH (ASOS-style)
      // Session active → close current menu instantly, open next instantly.
      if (megaMenuSession) {
        clearTimeout(this._hoverIntentTimer);
        this._hoverIntentTimer = null;

        switchingMenus = true;
        const nav = this.closest('nav');
        if (nav) {
          nav.querySelectorAll('mega-menu-disclosure').forEach(d => {
            if (d !== this && d.disclosureElement.getAttribute('aria-expanded') === 'true') {
              originalClose.call(d);
            }
          });
        }
        switchingMenus = false;

        startSession();
        return originalOpen.call(this, { instant: true });
      }

      // HOVER INTENT
      // First open in a session — wait 500ms before opening.
      if (!this._hoverIntentTimer) {
        this._hoverIntentTimer = setTimeout(() => {
          this._hoverIntentTimer = null;
          startSession();
          originalOpen.call(this, options);
        }, HOVER_INTENT_DELAY);
      }
    };

    MegaMenuDisclosure.prototype.close = function () {
      clearTimeout(this._hoverIntentTimer);
      this._hoverIntentTimer = null;
      if (this.disclosureElement.getAttribute('aria-expanded') === 'true') {
        scheduleSessionEnd();
      }
      return originalClose.call(this);
    };
  });
})();
